import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = { class: "pb-10" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "overview"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#overview" }),
  /*#__PURE__*/_createTextVNode(" Overview ")
], -1)
const _hoisted_5 = { class: "py-5" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" extends ")
const _hoisted_7 = /*#__PURE__*/_createVNode("a", {
  href: "https://getbootstrap.com/docs/5.0/utilities/borders/",
  class: "fw-bold"
}, "Bootstrap Borders", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("; in ")
const _hoisted_9 = /*#__PURE__*/_createVNode("code", null, "src/sass/helpers/_borders.scss", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" to provide additional border utility classes to cover its own design system. ")
const _hoisted_11 = { class: "py-10" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-3\" id=\"border-styles\"><a href=\"#border-styles\"></a> Border Styles </h1><div class=\"py-5\"> Use <code>.border-dashed</code> or <code>.border-dotted</code> classes to set an element&#39;s border style. </div><div class=\"py-5\"><div class=\"rounded border p-10\"><div class=\"d-flex flex-wrap align-items-center\"><div class=\"border w-150px h-150px d-flex flex-center me-5 mb-5 fw-bold\"> default style </div><div class=\"border border-dashed w-150px h-150px d-flex flex-center me-5 mb-5 fw-bold\"> .border-dashed </div><div class=\"border border-dotted w-150px h-150px d-flex flex-center me-5 mb-5 fw-bold\"> .border-dotted </div></div></div></div>", 3)
const _hoisted_15 = { class: "py-5" }
const _hoisted_16 = { class: "py-10" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-3\" id=\"border-states\"><a href=\"#border-states\"></a> Border States </h1><div class=\"py-5\"> Use <code>.border-hover</code> to display an element&#39;s border on hover and <code>.border-active</code> to enable the border when <code>.active</code> class is applied. </div><div class=\"py-5\"><div class=\"rounded border p-10\"><div class=\"d-flex flex-wrap align-items-center\"><div class=\"border border-primary border-hover w-150px h-150px d-flex flex-center me-5 mb-5 fw-bold\"> .border-hover </div><div class=\"border border-primary border-active active w-150px h-150px d-flex flex-center me-5 mb-5 fw-bold\"> .border-active<br>.active </div></div></div></div>", 3)
const _hoisted_20 = { class: "py-5" }
const _hoisted_21 = { class: "pt-10" }
const _hoisted_22 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "border-gray-colors"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#border-gray-colors" }),
  /*#__PURE__*/_createTextVNode(" Border Gray Colors ")
], -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".border-gray-{100, 200, 300, 400, 500, 600, 700, 800, 900}"),
  /*#__PURE__*/_createTextVNode(" to set an element's border color. ")
], -1)
const _hoisted_24 = { class: "py-5" }
const _hoisted_25 = { class: "rounded border p-10" }
const _hoisted_26 = { class: "d-flex flex-wrap align-items-center" }
const _hoisted_27 = { class: "pt-5" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
            <div class="border border-gray-100"></div>
            <div class="border border-gray-200"></div>
            <div class="border border-gray-300"></div>
            <div class="border border-gray-400"></div>
            <div class="border border-gray-500"></div>
            <div class="border border-gray-600"></div>
            <div class="border border-gray-700"></div>
            <div class="border border-gray-800"></div>
            <div class="border border-gray-900"></div>
            `))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("b", null, _toDisplayString(_ctx.themeName), 1),
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode("div", _hoisted_15, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`
            <div class="border">
              default style
            </div>

            <div class="border border-dashed">
              .border-dashed
            </div>

            <div class="border border-dotted">
              .border-dotted
            </div>
            `), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode("div", _hoisted_20, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`
            <div class="border border-primary border-hover">
              .border-hover
            </div>

            <div class="border border-primary border-active active">
              .border-dashed
            </div>
            `), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_21, [
        _hoisted_22,
        _hoisted_23,
        _createVNode("div", _hoisted_24, [
          _createVNode("div", _hoisted_25, [
            _createVNode("div", _hoisted_26, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gray, (item, i) => {
                return (_openBlock(), _createBlock("div", {
                  key: i,
                  class: [`border-${item}`, "w-100px h-100px d-flex flex-center p-3 me-5 mb-5 fw-bold border"]
                }, " .border-" + _toDisplayString(item), 3))
              }), 128))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_27, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}